import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8802b836"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mobile-symbol-icon mobile-symbol-icon--profile",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m12 3 8 4.5-8 4.5-8-4.5L12 3Z" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m4 12 8 4.5 8-4.5" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m4 16.5 8 4.5 8-4.5" }, null, -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "18",
  height: "14",
  x: "3",
  y: "5",
  rx: "2"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m3 7 9 6 9-6" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  viewBox: "70 55 1080 890",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polygon", { points: "357.1 918 358.2 613.4 1107.4 103.7 1109.1 405.2 357.1 918" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M347.4,105.7c-17.3,7.9-34,16.8-50,26.8l-15.3,10.1c-111.6,76.8-184.9,205.3-184.9,351s27.7,172.6,74.9,241.1l184.9-121.7V102.3l-9.7,3.4Z" }, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 4,
  class: "mobile-symbol-svg mobile-symbol-svg--info",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M14.8 7.2c-.6-1.2-1.7-1.9-3.1-1.9-1.8 0-3 .9-3 2.3 0 1.5 1.3 2.1 3.3 2.8 2.2.8 3.5 1.5 3.5 3.3 0 1.6-1.4 2.8-3.6 2.8-1.6 0-2.9-.7-3.6-1.9" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.1 19.1c.6 1.1 1.7 1.6 3.1 1.6 1.8 0 3-.9 3-2.3 0-1.5-1.3-2.1-3.3-2.8-2.2-.8-3.5-1.5-3.5-3.3 0-1.6 1.4-2.8 3.6-2.8 1.4 0 2.6.5 3.3 1.4" }, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 5,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "8.5"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m15.2 8.8-2.1 5.1-5.1 2.1 2.1-5.1 5.1-2.1Z" }, null, -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 6,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<path d=\"M9 5.2a3 3 0 0 0-4 4.4 3.3 3.3 0 0 0 .2 5.2A3 3 0 0 0 9 19\" data-v-8802b836></path><path d=\"M15 5.2a3 3 0 0 1 4 4.4 3.3 3.3 0 0 1-.2 5.2A3 3 0 0 1 15 19\" data-v-8802b836></path><path d=\"M9 5v14\" data-v-8802b836></path><path d=\"M15 5v14\" data-v-8802b836></path><path d=\"M9 9h3\" data-v-8802b836></path><path d=\"M12 15h3\" data-v-8802b836></path>", 6)
const _hoisted_30 = [
  _hoisted_24
]
const _hoisted_31 = {
  key: 7,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12 3 20 6v6c0 4.5-3.1 7.4-8 9-4.9-1.6-8-4.5-8-9V6l8-3Z" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m8.8 12.2 2.1 2.1 4.5-5" }, null, -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 8,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "12",
  x: "4",
  y: "7",
  rx: "2"
}, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M8 7V5.8A1.8 1.8 0 0 1 9.8 4h4.4A1.8 1.8 0 0 1 16 5.8V7" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M4 12h16" }, null, -1))
const _hoisted_39 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.type === 'profile')
    ? (_openBlock(), _createElementBlock("span", _hoisted_1))
    : (_ctx.type === 'expertise')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_6))
      : (_ctx.type === 'contact')
        ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
        : (_ctx.type === 'vecura')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_14))
          : (_ctx.type === 'info')
            ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_18))
            : (_ctx.type === 'compass')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_22))
              : (_ctx.type === 'brain')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_30))
                : (_ctx.type === 'shield')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_34))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_35, _hoisted_39))
}